import {ProjectContext} from '@context/ProjectContext';
import LogoGoldIcon from '@icons/LogoGoldIcon';
import LogoIcon from '@icons/LogoIcon';
import MenuIcon from '@icons/MenuIcon';
import ProfileIcon from '@icons/ProfileIcon';
// @ts-ignore
import shahadatLogo from '@icons/shahadatLogo.png';
import {IconButton} from '@mui/material';
import {Stack} from '@mui/system';
import {useContext, useState} from 'react';
import {Link} from 'react-router-dom';
import Drawer from './Drawer';

export default function Header() {
	const context = useContext(ProjectContext);
	const [open, setOpen] = useState(false);
	
	const handleOpen = () => {
		setOpen(true);
	};
	
	const handleClose = () => {
		setOpen(false);
	};
	
	return (
		<Stack className="mx-4 h-20" direction="row" alignItems="center" justifyContent="space-between">
			<IconButton onClick={handleOpen}>
				<MenuIcon/>
			</IconButton>
			{
				context.shahadat ? <img src={shahadatLogo} alt=""/> : <LogoIcon/>
				// context.shahadat ? <img src={shahadatLogo} alt=""/> : <LogoGoldIcon/>
			}
			<IconButton component={Link} to="/profile">
				<ProfileIcon/>
			</IconButton>
			<Drawer open={open} handleClose={handleClose}/>
		</Stack>
	);
}
